// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { EntityKindFromJSON, EntityKindToJSON, } from './';
export function ExportDataExcelRequestFromJSON(json) {
    return {
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'entityKind': !exists(json, 'entityKind') ? undefined : EntityKindFromJSON(json['entityKind']),
        'entityIds': json['entityIds'],
        'fromDate': !exists(json, 'fromDate') ? undefined : new Date(json['fromDate']),
        'toDate': !exists(json, 'toDate') ? undefined : new Date(json['toDate']),
        'includeInvestorAccounts': !exists(json, 'includeInvestorAccounts') ? undefined : json['includeInvestorAccounts'],
        'includeCustomFields': !exists(json, 'includeCustomFields') ? undefined : json['includeCustomFields'],
        'includeEsgData': !exists(json, 'includeEsgData') ? undefined : json['includeEsgData'],
    };
}
export function ExportDataExcelRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'name': value.name,
        'description': value.description,
        'entityKind': EntityKindToJSON(value.entityKind),
        'entityIds': value.entityIds,
        'fromDate': value.fromDate === undefined ? undefined : value.fromDate.toISOString(),
        'toDate': value.toDate === undefined ? undefined : value.toDate.toISOString(),
        'includeInvestorAccounts': value.includeInvestorAccounts,
        'includeCustomFields': value.includeCustomFields,
        'includeEsgData': value.includeEsgData,
    };
}
